import {createContext, useContext, useState, useEffect} from 'react'
import {accountApi} from '../services'

const Context = createContext()

export const useAuth = () => {
    const context = useContext(Context)
    if (!context) {
        throw new Error('This context hook must be used within its provider')
    }
    return context
}

export const AuthProvider = ({children}) => {
    const [accountLoading, setAccountLoading] = useState(true)
    const [account, setAccount] = useState(null)
    const [user, setUser] = useState(null)
    const [organization, setOrganization] = useState(null)
    const [roles, setRoles] = useState([])
    const [permissions, setPermissions] = useState(null)
    const [branches, setBranches] = useState([])

    useEffect(() => {
        setAccountLoading(true)
        accountApi
            .getAccount()
            .then(({data: {data}}) => {
                setAccountLoading(false)
                setAccount(data)
            })
            .catch(() => {
                setAccountLoading(false)
                setAccount(null)
            })
    }, [])

    useEffect(() => {
        setUser(account?.user)
        setOrganization(account?.organization)
        setRoles(account?.roles)
        setPermissions(account?.permissions)
        if (account?.branches && account?.branches.length > 0) {
            setBranches([{branch_id: 'all', branch_name: 'All Branches'}, ...account?.branches])
        }
    }, [account])

    const value = {
        account,
        setAccount,
        user,
        organization,
        roles,
        permissions,
        branches,
        accountLoading,
        isAuthenticated: !!account,
    }

    return <Context.Provider value={value}>{children}</Context.Provider>
}
